// @ts-nocheck

// Список продуктовых карточек в виде слайдера
document
    .querySelectorAll("[data-product-card-list-slider]")
    .forEach((element) => {
        try {
            const scrollArea =
                /** @type {HTMLDivElement} */ element.querySelector(
                    "[data-scroll-area]",
                );
            const leftBtn =
                /** @type {HTMLButtonElement} */ element.querySelector(
                    "[data-left-btn]",
                );
            const rightBtn =
                /** @type {HTMLButtonElement} */ element.querySelector(
                    "[data-right-btn]",
                );

            updateScrollButtons();

            leftBtn.addEventListener("click", () => {
                scrollArea.scrollTo({
                    left: scrollArea.scrollLeft - scrollArea.clientWidth,
                    behavior: "smooth",
                });
            });

            rightBtn.addEventListener("click", () => {
                scrollArea.scrollTo({
                    left: scrollArea.scrollLeft + scrollArea.clientWidth,
                    behavior: "smooth",
                });
            });

            scrollArea.addEventListener("scrollend", updateScrollButtons);
            new ResizeObserver(updateScrollButtons).observe(scrollArea);

            // Обновить состояние кнопок прокрутки влево/вправо.
            // Если все карточки умещаются в область, то кнопки невидимы.
            // Если некуда прокручивать, то кнопка неактивная.
            function updateScrollButtons() {
                if (scrollArea.scrollWidth <= scrollArea.clientWidth) {
                    leftBtn.classList.add("display-none");
                    rightBtn.classList.add("display-none");
                } else {
                    leftBtn.classList.remove("display-none");
                    rightBtn.classList.remove("display-none");
                    leftBtn.disabled = scrollArea.scrollLeft <= 0;
                    rightBtn.disabled =
                        scrollArea.scrollLeft >=
                        scrollArea.scrollWidth - scrollArea.clientWidth;
                }
            }
        } catch (err) {
            console.error(err);
        }
    });

// Расширяемый список продуктовых карточек
document
    .querySelectorAll("[data-product-card-list-expandable]")
    .forEach((element) => {
        try {
            const list =
                /** @type {HTMLDivElement} */ element.querySelector(
                    "[data-list]",
                );
            const showMoreBtn =
                /** @type {HTMLButtonElement} */ element.querySelector(
                    "[data-show-more-btn]",
                );
            const showLessBtn =
                /** @type {HTMLButtonElement} */ element.querySelector(
                    "[data-show-less-btn]",
                );

            showMoreBtn.addEventListener("click", () => {
                list.dataset.expanded = "true";
                showMoreBtn.classList.toggle("display-none", true);
                showLessBtn.classList.toggle("display-none", false);
            });

            showLessBtn.addEventListener("click", () => {
                list.dataset.expanded = "false";
                showMoreBtn.classList.toggle("display-none", false);
                showLessBtn.classList.toggle("display-none", true);
            });
        } catch (err) {
            console.error(err);
        }
    });
